<template>
  <page-main
    :tableData="tableData"
    :loading="loading"
    @reload="getData"
    :disabled="disabled"
  >
  </page-main>
</template>
<script>
import PageMain from './main'
import BaseTable from '@/mixins/base-table'
export default {
  components: {
    PageMain,
  },
  mixins: [BaseTable],
  props: {
    planOrderSpecDetailCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {}
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$api
        .planOrderSpecDetailScheduleListApi({
          planOrderSpecDetailCode: this.planOrderSpecDetailCode,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
